import { AppBar, Button, IconButton, Toolbar, Typography } from '@mui/material';
import React, { CSSProperties, useEffect, useState } from 'react';

import AssetService from '../services/AssetService';
import Avatar from '@mui/material/Avatar';
import BackIcon from '@mui/icons-material/ArrowBack';
import { CollectionVm } from '../../content/models/ResourceModel/Collection';
import CourseVm from '../../content/models/CourseVm';
import Grid from '@mui/material/Unstable_Grid2';
import Pathway from '../../dashboard/models/Pathway';
import { TooltipComponent } from './TooltipComponent';
import { styled } from '@mui/system';
import styles from '../styles/CourseDialog.module.scss';

const StyledDiv = styled('div')(({ theme }) => ({
  flex: 1,
  '@media (min-width: 500px)': {
    marginLeft: theme.spacing(2)
  }
}));

const StyledAvatar = styled(Avatar)(({ theme }) => ({
  width: theme.spacing(8),
  height: theme.spacing(8),
  fontSize: '24px',
  '@media (max-width: 500px)': {
    width: theme.spacing(6),
    height: theme.spacing(6),
    fontSize: '20px'
  },
  backgroundColor: theme.palette.grey[500]
}));

/** custom IconButton to reduce padding for mobile view */
export const CustomIconButton = styled(IconButton)({
  root: {
    '@media (max-width: 500px)': {
      padding: '5px',
      '&.MuiIconButton-root': {
        padding: '5px'
      }
    }
  }
});

export interface IContentAppBar {
  label: string;
  content: CourseVm | CollectionVm | Pathway;
  disable?: boolean;
  handleClose: () => void;
}

/** Used in both course and collection list page */
const ContentAppBar = (props: IContentAppBar) => {
  const { label, content, handleClose } = props;

  const [avatarStyle, setAvatarStyle] = useState<CSSProperties>();
  const [avatarImage, setAvatarImage] = useState('');

  useEffect(() => {
    const displaySettings = props.content?.displaySettings;
    if (displaySettings?.icon?.type === 'color') {
      setAvatarStyle({
        backgroundColor: props.content.displaySettings.icon.value || '#9e'
      });
    }
    if (displaySettings?.icon?.type === 'image') {
      setAvatarImage(
        AssetService.getAssetUrl(props.content.displaySettings.icon.value)
      );
    }
  }, [props.content]);

  return (
    <AppBar className={styles.appBar}>
      <Toolbar>
        <CustomIconButton
          edge="start"
          color="inherit"
          disabled={props.disable}
          onClick={handleClose}
          aria-label="close"
        >
          <BackIcon />
        </CustomIconButton>
        <StyledDiv>
          <Grid container alignItems="center" wrap="nowrap">
            <Grid
              className={`${styles.itemSpacing} ${styles.courseImage}`}
              minWidth={'unset'}
            >
              <StyledAvatar style={avatarStyle} src={avatarImage}>
                {content?.title?.toUpperCase()[0]}
              </StyledAvatar>
            </Grid>
            <Grid className={styles.itemSpacing} minWidth={'unset'}>
              <Grid container direction="column">
                <Grid className={styles.courseInfo}>
                  <Typography variant="caption">{label}</Typography>
                </Grid>
                <TooltipComponent label={content?.title} variant="h6" />
                <TooltipComponent
                  label={content?.description}
                  variant="caption"
                />
              </Grid>
            </Grid>
          </Grid>
        </StyledDiv>
        <Button
          autoFocus
          color="inherit"
          disabled={props.disable}
          onClick={handleClose}
          className={styles.hideButton}
        >
          Back
        </Button>
      </Toolbar>
    </AppBar>
  );
};
export default ContentAppBar;
